(() => {
  const menuToggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#PrimaryNav');
  menuToggle?.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') !== 'true';
    menuToggle.setAttribute('aria-expanded', String(open));
    nav.classList.toggle('open', open);
  });
  const collections = document.querySelector('.collections-wrap');
  const trigger = document.querySelector('.collections-toggle');
  const menu = document.querySelector('#CollectionsMenu');
  const setOpen = open => { if (!trigger || !menu) return; trigger.setAttribute('aria-expanded', String(open)); menu.hidden = !open; };
  trigger?.addEventListener('click', () => setOpen(matchMedia('(hover: hover)').matches ? true : menu.hidden));
  collections?.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) setOpen(true); });
  collections?.addEventListener('mouseleave', () => { if (!collections.contains(document.activeElement)) setOpen(false); });
  document.addEventListener('click', event => { if (collections && !collections.contains(event.target)) setOpen(false); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') setOpen(false); });
  menu?.addEventListener('click', event => { if (event.target.closest('a')) setOpen(false); });
  const video = document.querySelector('.hero-video video, video.hero-video');
  const videoToggle = document.querySelector('.video-toggle');
  videoToggle?.addEventListener('click', () => {
    if (!video) return;
    if (video.paused) video.play().catch(() => {}); else video.pause();
    videoToggle.textContent = video.paused ? videoToggle.dataset.play : videoToggle.dataset.pause;
  });
})();
